import React, { useEffect, useState } from 'react';
import { Link, useParams } from 'react-router-dom';
import { getAppStoreLinks } from '../services/appStoreLinks';
import { APP_AUDIENCES, STORE_PLATFORMS, findAvailableStoreLink } from '../utils/appStoreLinks';
import AppDownloadCard from '../components/Downloads/AppDownloadCard';
import { useParentTheme } from '../contexts/ParentThemeContext';
import './EntryPortal.css';

export default function AppDownload() {
  const { audience, platform } = useParams();
  const { isDark } = useParentTheme();
  const [status, setStatus] = useState('loading');
  const [attempt, setAttempt] = useState(0);
  const valid = APP_AUDIENCES.includes(audience) && (!platform || STORE_PLATFORMS.includes(platform));

  useEffect(() => {
    if (!valid || !platform) return;
    let active = true;
    setStatus('loading');
    getAppStoreLinks({ fresh: true }).then((links) => {
      if (!active) return;
      const url = findAvailableStoreLink(links, audience, platform);
      if (url) window.location.replace(url);
      else setStatus('soon');
    }).catch(() => { if (active) setStatus('error'); });
    return () => { active = false; };
  }, [audience, platform, valid, attempt]);

  const message = !valid ? 'Download not found' : status === 'error' ? 'Downloads are temporarily unavailable' : status === 'soon' ? 'Coming soon' : 'Opening the store…';
  return (
    <div className={`mypiggy-entry${isDark ? ' dark' : ''}`}>
      <main className="min-h-screen bg-white p-4 text-slate-900 dark:bg-slate-950 dark:text-white">
        <div className="mx-auto max-w-md">
          {!platform && valid ? <AppDownloadCard audience={audience} /> : (
            <div className="rounded-3xl border border-slate-200 p-6 text-center dark:border-slate-700">
              <h1 className="text-2xl font-extrabold" role="status">{message}</h1>
              {valid && status === 'soon' && <p className="mt-3">This MyPiggy app is not available in this store yet.</p>}
              {status === 'error' && <button type="button" onClick={() => setAttempt((value) => value + 1)} className="mt-4 rounded-xl bg-teal-700 px-5 py-3 font-bold text-white">Try again</button>}
              <Link to="/" className="mt-5 inline-block font-bold text-teal-700 underline dark:text-teal-200">Back to MyPiggy</Link>
            </div>
          )}
        </div>
      </main>
    </div>
  );
}
